import { useState, useEffect } from "react";
import * as MUI from "@mui/material";
import { LayoutConsultaMandado } from "./LayoutConsultaMandado";
import { FaceCapture } from "../../../components";
import { useAuth } from "../../../hooks/auth";
import { useMandadoFacial } from "./hooks/use-mandado-facial.hook";
import { FormularioPesquisaFacial } from "./components/formulario-pesquisa-facial";
import { PreviewFotoSelecionada } from "./components/preview-foto-selecionada";
import { ResultadosReconhecimento } from "./components/resultados-reconhecimento";
import { LoadingReconhecimento } from "./components/loading-reconhecimento";
import { InfoConsultaBNMP } from "../../../components/informativos/consulta-bnmp";
import { verificarAcessoFacial } from "./services/reconhecimento-facial.service";

export const FiltroMandadoFacial: React.FC = () => {
  const { user } = useAuth();

  const cpfUsuario = user?.cpf || "";

  const [latitude, setLatitude] = useState<string | undefined>(undefined);
  const [longitude, setLongitude] = useState<string | undefined>(undefined);

  // null = verificando acesso; true = habilitado; false = bloqueado
  const [acessoFacial, setAcessoFacial] = useState<boolean | null>(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude.toString());
          setLongitude(position.coords.longitude.toString());
        },
        (error) => {
          console.warn("⚠️ Não foi possível obter localização:", error.message);
        }
      );
    }
  }, []);

  useEffect(() => {
    verificarAcessoFacial()
      .then(({ enabled }) => setAcessoFacial(enabled))
      .catch(() => setAcessoFacial(false));
  }, []);

  const {
    control,
    handleSubmit,
    watch,
    loading,
    showFaceCapture,
    setShowFaceCapture,
    resultadoReconhecimento,
    mensagemMandado,
    fotoEnviada,
    limparConsulta,
    handleFaceCaptured,
    pesquisarReconhecimentoFacial,
  } = useMandadoFacial(cpfUsuario, latitude, longitude);

  const fotoAtual = watch("foto");

  return (
    <LayoutConsultaMandado>
      <MUI.Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          overflowX: { xs: "hidden", sm: "visible" },
          overflowY: { xs: "visible", sm: "visible" },
          minHeight: { xs: "100%", sm: "auto" },
        }}
      >
        {acessoFacial === null && (
          <MUI.Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={200}
          >
            <MUI.CircularProgress />
          </MUI.Box>
        )}

        {acessoFacial === false && <InfoConsultaBNMP />}

        {acessoFacial === true && (
          <>
            <MUI.Stack flexDirection={["column", "row"]} gap={1}>
              <MUI.Typography variant="body1" fontWeight="bold">
                PESQUISA FACIAL
              </MUI.Typography>
            </MUI.Stack>

            <FormularioPesquisaFacial
              onSubmit={handleSubmit(pesquisarReconhecimentoFacial)}
              onLimpar={limparConsulta}
              onAbrirCaptura={() => setShowFaceCapture(true)}
              loading={loading}
              control={control}
            />

            <PreviewFotoSelecionada foto={fotoAtual} />

            <ResultadosReconhecimento
              resultado={resultadoReconhecimento}
              mensagem={mensagemMandado}
              loading={loading}
              fotoEnviada={fotoEnviada}
            />

            <LoadingReconhecimento open={loading} />

            <FaceCapture
              open={showFaceCapture}
              onClose={() => setShowFaceCapture(false)}
              onCaptured={handleFaceCaptured}
              title="Captura de Face - Reconhecimento"
            />
          </>
        )}
      </MUI.Box>
    </LayoutConsultaMandado>
  );
};
